<!--  -->
<template>
  <div class>
    <el-dialog
      title="ISE评议"
      align="center"
      @close="handleClose"
      :visible.sync="dialogVisible"
      width="640px"
    >
      <div class="paper">
        <h5 class="title">[J] 国外图书馆微博客建设及其启示</h5>

        <p>
          <span class="title">关键词：</span>图书馆／微博客／TWITTER／国外
        </p>
        <p>
          <span class="title">内容提要：</span>文章通过对国外图书馆微博客的调查,从微博客站点的数量、建站方式、建站软件、主题内容和提供的功能等五个方面,对国外图书馆微博客建设的现状进行了分析,总结归纳出国外图书馆微博客建设中存在的问题,并为国内图书馆微博客的建设提出了一些建议。
        </p>
        <p class="mb20">
          <span class="title">作者自评：</span>作者自评作者自评作者自评作者自评作者自评作者自评作者自评作者自评作者自评作者自评作者自评作者自评作者自评作者自评作者自评。
        </p>
        <!-- <a href class="rdfyk">人大复印库全文阅读 ></a> -->
        <h5 class="title mt20">您的ISE评论结论</h5>
        <div class="comment-btn">
          <el-button
            @click="changeBtn(item)"
            v-for="(item,index) in btnData"
            :key="index"
            :class="btnActive==index?'btn-active':''"
            plain
          >{{item.name}}</el-button>
        </div>
        <h5 class="title mt20">您的ISE评论描述</h5>
        <el-input type="textarea" :rows="4" placeholder="限100字以内" v-model="textarea"></el-input>
      </div>
      <el-button
            plain
            class="submitbtn mt30"
          >提交ISE评议</el-button>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      data: {},
      textarea:"",
      btnData: [
        {
          name: "重大突破成果",
          index: 0
        },
        {
          name: "一般突破成果",
          index: 1
        },
        {
          name: "没有突破成果",
          index: 2
        }
      ],
      btnActive: 0
    };
  },
  props: {
    commentValue: String
    // props: ['post'],
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open() {
      this.dialogVisible = true;
      console.log(11111111);
      //   this.$nextTick(() => {
      //   });
    },
    handleClose() {
      console.log(this.dialogVisible);
    },
    changeBtn(item) {
      this.btnActive = item["index"];
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.mb20 {
  margin-bottom: 20px;
}
.mt30{
  margin-top: 30px;
}
.mt20 {
  margin-top: 20px;
}
.paper {
  text-align: left;
  padding: 0 20px;
}
.paper h5 {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.paper .rdfyk {
  color: #4267b2;
}
.paper .rdfyk::before {
  content: " ";
  background: url("../../assets/rdfyk.svg") no-repeat;
  background-size: 100%;
  margin-right: 5px;
  position: relative;
  top: 2px;
  display: inline-block;
  height: 14px;
  width: 16px;
}
.comment-btn button {
  width: 150px;
  height: 40px;
  margin-right: 35px;
  position: relative;
}
.comment-btn button:last-child {
  margin-right: 0;
}
.comment-btn button:hover {
  color: #fff !important;
  background-color: #4267b2 !important;
  border-color: #4267b2 !important;
}
.btn-active {
  background-color: #4267b2 !important;
  color: #fff !important;
  border-color: #4267b2 !important;
}
.submitbtn{
  background-color: #4267b2 !important;
  color: #fff !important;
  border-color: #4267b2 !important;
}
.btn-active::before {
  content: " ";
  background: url("../../assets/img/comment.png") no-repeat;
  background-size: 100%;
  position: absolute;
  top: 1px;
  right: 1px;
  height: 25px;
  width: 30px;
  border-top-right-radius: 4px;
  z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/view/common/papercomment.vue